import { Spinner } from "../ui/Spinner";

export type OptionState = "idle" | "loading" | "correct" | "wrong" | "disabled";

interface Props {
  testo: string;
  index: number;
  state: OptionState;
  onClick: (index: number) => void;
}

const stateClasses: Record<OptionState, string> = {
  idle: "border-border hover:border-secondary bg-card",
  loading: "border-accent bg-card",
  correct: "border-green bg-green/20 text-primary",
  wrong: "border-red-500 bg-red-500/10 text-primary",
  disabled: "border-border bg-card opacity-50",
};

const letter = (i: number) => String.fromCharCode(65 + i); // 0→A

export function OptionButton({ testo, index, state, onClick }: Props) {
  const disabled = state !== "idle";
  return (
    <button
      type="button"
      onClick={() => !disabled && onClick(index)}
      disabled={disabled}
      className={`
        w-full text-left rounded-xl border-2 p-4
        transition-all duration-150
        flex items-center gap-4
        ${disabled ? "cursor-not-allowed" : "cursor-pointer"}
        ${stateClasses[state]}
      `}
    >
      <span
        className={`
          flex-none w-9 h-9 rounded-lg flex items-center justify-center
          font-mono font-bold text-sm
          ${state === "correct" ? "bg-green text-white" : ""}
          ${state === "wrong" ? "bg-red-500 text-white" : ""}
          ${state === "loading" ? "bg-accent text-white" : ""}
          ${state === "idle" || state === "disabled" ? "bg-bg text-secondary border border-border" : ""}
        `}
      >
        {state === "loading" ? <Spinner size={14} /> : letter(index)}
      </span>
      <span className="flex-1 text-primary">{testo}</span>
      {state === "correct" && <span className="text-xl">✓</span>}
      {state === "wrong" && <span className="text-xl">✗</span>}
    </button>
  );
}
